import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import { ReactComponent as LightLogoElisyan } from "../assets/images/light_logo_elisyan.svg";
import { ReactComponent as DarkLogoElisyan } from "../assets/images/logo_dark_elisyan.svg";
import { ReactComponent as LightLogoSopher } from "../assets/images/light_logo_sopher.svg";
import { ReactComponent as DarkLogoSopher } from "../assets/images/dark_logo_sopher.svg";
//import { ReactComponent as HamburgerIcon } from '../assets/images/profile icon elisyan.svg'; // Add a hamburger icon SVG
//import { ReactComponent as ToggleDarkIcon } from '../assets/images/swap-off.svg';
//import { ReactComponent as ToggleLightIcon } from '../assets/images/swap-on.svg'; // Add a hamburger icon SVG
import { ReactComponent as LightLogoSopherAcounting } from "../assets/images/LOGO-Sopher-Accounting-light-mode.svg";
import { ReactComponent as DarkLogoSopherAcounting } from "../assets/images/LOGO-Sopher-Accounting-dark-mode.svg";
import { ReactComponent as LightLogoOlympeAcounting } from "../assets/images/logo-light-olympe.svg";
import { ReactComponent as DarkLogoOlympeAcounting } from "../assets/images/logo-dark-olympe.svg";
import { ReactComponent as LightLogoAurum } from "../assets/images/AurumLogodashboard.svg";
import { ReactComponent as LightLogoAdamBenedict } from "../assets/images/AdamBenedict WhiteLogonobackground.svg";
import "../assets/styles/index.css";
import "../assets/styles/index.css";
import useCustomStyles from "../hooks/useCustomStyles";
import { customStyles } from "../assets/styles/header";
import { header2Styles } from "../assets/styles/header2";
import { setIsSideNavOpen } from "../store/slices/authSlice";
import ProfileSection from "./Profile";

function Header2() {
  const { theme, activeTheme, mode } = useSelector(
    (state: RootState) => state.theme_slice
  );
  const dispatch = useDispatch<AppDispatch>();
  const classes = useCustomStyles(customStyles, theme);
  const classes1 = useCustomStyles(header2Styles, theme);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenuNavProfile = () => {
   
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    dispatch(setIsSideNavOpen());
  };
 
  // Function to determine the correct logo
  const getLogo = () => {
    if (theme?.colorSchema?.logo?.primary?.light) {
      //console.log('Using business theme logo:', theme.colorSchema.logo.main.light);
      return (
        <img 
          src={theme?.colorSchema?.logo?.primary?.light}
          alt="header logo"
          width={theme?.colorSchema?.logo?.primary?.style?.width ? theme.colorSchema.logo.primary.style.width : 150}
          height={theme?.colorSchema?.logo?.primary?.style?.height ? theme.colorSchema.logo.primary.style.height : 50}
          style={{ objectFit: 'contain' }}
          onError={(e) => {
            console.warn('Failed to load business logo, falling back to static');
            e.currentTarget.style.display = 'none';
          }}
        />
      );
    }
    if (activeTheme === "elisyan") {
      return mode === "light" ? (
        <LightLogoElisyan width={150} height={35} />
      ) : (
        <DarkLogoElisyan width={150} height={55} />
      );
    } else if (activeTheme === "sopher") {
      return mode === "light" ? (
        <LightLogoSopher width={150} height={50} />
      ) : (
        <DarkLogoSopher width={150} height={50} />
      );
    } else if (activeTheme === "sopheraccounting") {
      return mode === "light" ? (
        <LightLogoSopherAcounting width={150} height={50} />
      ) : (
        <DarkLogoSopherAcounting width={150} height={50} />
      );
    } else if (activeTheme === "olympe") {
      return mode === "light" ? (
        <LightLogoOlympeAcounting width={75} height={50} />
      ) : (
        <DarkLogoOlympeAcounting width={75} height={50} />
      );
    } else if (activeTheme === "adambenedict") {
      return mode === "light" ? (
        <LightLogoAdamBenedict width={150} height={50} />
      ) : (
        <LightLogoAdamBenedict width={150} height={50} />
      );
    } else if (activeTheme === "aurum") {
      return mode === "light" ? (
        <LightLogoAurum width={150} height={50} />
      ) : (
        <LightLogoAurum width={150} height={50} />
      );
    }
    return null; 
  };

  return (
    <div className={classes?.container}>
      <div className={classes?.logo} onClick={() => toggleMenu()}>
        {getLogo()} {/* Dynamically rendered logo */}
      </div>
      <div
        className={classes1?.hamburgerIcon}
        onClick={() => toggleMenuNavProfile()}
      >
        <ProfileSection />

        {/* {getMenuIcon()} */}
      </div>
    </div>
  );
}

export default Header2;
